import { type ModelsKey } from '~/context/srp/AppliedFiltersContext';
import type { FacetLists, FacetRanges } from '~/contracts/srp';

export type FacetBooleanKeys = 'isFreeDelivery';
export type FacetListKeys = keyof FacetLists | 'tagIds';
export type FacetRangeKeys = keyof FacetRanges;

export const booleanFacets: FacetBooleanKeys[] = ['isFreeDelivery'];

export const rangeFacets: Array<FacetRangeKeys | 'finance'> = [
  'finance',
  'mileage',
  'mpg',
  'price',
  'seatingCapacity',
  'towingCapacity',
  'year'
];

export const listFacets: FacetListKeys[] = [
  'bodyStyles',
  'colors',
  'cvnaFeatures',
  'cylinderCounts',
  'driveTypes',
  'features',
  'fuelTypes',
  'interiorColors',
  'sizeClasses',
  'tagIds',
  'transmissions',
  'truckCabTypes',
  'truckBedLengths'
];

export const facetsWithDisplayName: Array<FacetListKeys | 'isFreeDelivery'> = [
  'isFreeDelivery',
  ...listFacets
];

export type FacetKey =
  | FacetBooleanKeys
  | FacetListKeys
  | FacetRangeKeys
  | 'makes'
  | 'finance';

export type Tag = {
  context:
    | {
        key: string;
        modelsKey?: never;
        parents?: never;
      }
    | {
        key: string;
        modelsKey: ModelsKey;
        parents: string[];
      };
  facetKey: FacetKey | 'earliestDayToDeliveryOrPickup';
  tagName: string;
};
